<p-accordion [multiple]="true" class="student-accordion">

    <!-- Overview / Admission -->
    <p-accordion-panel value="0">
        <p-accordion-header>Overview / Admission Details</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                    <label class="block mb-2">Admission Number</label>
                    <input pInputText [(ngModel)]="studentDetails.admission_number" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Roll Number</label>
                    <input pInputText [(ngModel)]="studentDetails.student_roll_no" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Admission ID</label>
                    <input pInputText [(ngModel)]="studentDetails.admission_id" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Academic Year</label>
                    <p-select [options]="academicYearList" appendTo="body" optionValue="id"
                        [(ngModel)]="studentDetails.academic_year" optionLabel="year_name"
                        class="profile-select w-full"></p-select>
                </div>
                <!-- admission_type -->
                <div>
                    <label class="block mb-2">Admission Type</label>
                    <p-select [options]="admissionTypeOptions" [(ngModel)]="studentDetails.admission_type"
                        appendTo="body"
                        class="profile-select w-full"></p-select>
                </div>
                <!-- admission_mode -->
                <div>
                    <label class="block mb-2">Admission Mode</label>
                    <p-select [options]="admissionModeOptions" [(ngModel)]="studentDetails.admission_mode"
                        appendTo="body"
                        class="profile-select w-full"></p-select>
                </div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Personal Info -->
    <p-accordion-panel value="1">
        <p-accordion-header>Personal Details</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                    <label class="block mb-2">First Name</label>
                    <input pInputText [(ngModel)]="studentDetails.first_name" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Middle Name</label>
                    <input pInputText [(ngModel)]="studentDetails.middle_name" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Last Name</label>
                    <input pInputText [(ngModel)]="studentDetails.last_name" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Gender</label>
                    <p-select [options]="genderOptions" [(ngModel)]="studentDetails.gender"
                        class="profile-select w-full"></p-select>
                </div>
                <div class="col-span-1">
                    <label class="block mb-2">Date of Birth</label>
                    <p-datepicker class="w-full  " appendTo="body" [inputStyle]="{
                                    'box-shadow':'none !important',
                                    'width': '100%',
                                    'border': 'none',
                                    'background-color': 'transparent',
                                    'border-radius': '10px',
                                }" [style]="{'box-shadow':'none !important',
                                    'width': '100%',
                                    'background-color': 'transparent',
                                    'border': 'none',
                                    'border-radius': '10px',
                                 }" [maxDate]="today" [(ngModel)]="studentDetails.dob"
                        name="date_of_birth" />
                    <div class="w-full profile-input h-[33px] -mt-[32px] z-50 rounded-[5px]">
                    </div>
                </div>
                <div>
                    <label class="block mb-2">Age</label>
                    <input pInputText [(ngModel)]="studentDetails.age" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Nationality</label>
                    <input pInputText [(ngModel)]="studentDetails.nationality" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Religion</label>
                    <input pInputText [(ngModel)]="studentDetails.religion" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Caste</label>
                    <input pInputText [(ngModel)]="studentDetails.caste" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Caste Category</label>
                    <input pInputText [(ngModel)]="studentDetails.caste_category" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Aadhar Number</label>
                    <input pInputText [(ngModel)]="studentDetails.aadhar_no" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Passport Number</label>
                    <input pInputText [(ngModel)]="studentDetails.passport_no" class="w-full profile-input" />
                </div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Contact Details -->
    <p-accordion-panel value="2">
        <p-accordion-header>Contact Details</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                    <label class="block mb-2">Email</label>
                    <input pInputText [(ngModel)]="studentDetails.email" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Alternate Email</label>
                    <input pInputText [(ngModel)]="studentDetails.alternate_email" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Phone</label>
                    <input pInputText [(ngModel)]="studentDetails.phone" class="w-full profile-input" />
                </div>
                <div>
                    <label class="block mb-2">Alternate Phone</label>
                    <input pInputText [(ngModel)]="studentDetails.alternate_phone" class="w-full profile-input" />
                </div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Address Details -->
    <p-accordion-panel value="3">
        <p-accordion-header>Address Details</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div><label>Address Line 1</label><input pInputText [(ngModel)]="studentDetails.address_line1"
                        class="w-full profile-input" /></div>
                <div><label>Address Line 2</label><input pInputText [(ngModel)]="studentDetails.address_line2"
                        class="w-full profile-input" /></div>
                <div><label>City</label><input pInputText [(ngModel)]="studentDetails.city"
                        class="w-full profile-input" /></div>
                <div><label>State</label><input pInputText [(ngModel)]="studentDetails.state"
                        class="w-full profile-input" /></div>
                <div><label>Postal Code</label><input pInputText [(ngModel)]="studentDetails.postal_code"
                        class="w-full profile-input" /></div>
                <div><label>Country</label><input pInputText [(ngModel)]="studentDetails.country"
                        class="w-full profile-input" /></div>
                <div><label>Permanent Address</label><input pInputText [(ngModel)]="studentDetails.permanent_address"
                        class="w-full profile-input" /></div>
                <div><label>Current Address</label><input pInputText [(ngModel)]="studentDetails.current_address"
                        class="w-full profile-input" /></div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Guardian -->
    <p-accordion-panel value="4">
        <p-accordion-header>Guardian Details</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div><label>Guardian Name</label><input pInputText [(ngModel)]="studentDetails.guardian_name"
                        class="w-full profile-input" /></div>
                <div><label>Guardian Relation</label><input pInputText [(ngModel)]="studentDetails.guardian_relation"
                        class="w-full profile-input" /></div>
                <div><label>Guardian Phone</label><input pInputText [(ngModel)]="studentDetails.guardian_phone"
                        class="w-full profile-input" /></div>
                <div><label>Guardian Email</label><input pInputText [(ngModel)]="studentDetails.guardian_email"
                        class="w-full profile-input" /></div>
                <div><label>Guardian Address</label><input pInputText [(ngModel)]="studentDetails.guardian_address"
                        class="w-full profile-input" /></div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Parents -->
    <p-accordion-panel value="5">
        <p-accordion-header>Parent Details</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div><label>Father Name</label><input pInputText [(ngModel)]="studentDetails.father_name"
                        class="w-full profile-input" /></div>
                <div><label>Father Phone</label><input pInputText [(ngModel)]="studentDetails.father_phone"
                        class="w-full profile-input" /></div>
                <div><label>Father Email</label><input pInputText [(ngModel)]="studentDetails.father_email"
                        class="w-full profile-input" /></div>
                <div><label>Father Occupation</label><input pInputText [(ngModel)]="studentDetails.father_occupation"
                        class="w-full profile-input" /></div>
                <div><label>Mother Name</label><input pInputText [(ngModel)]="studentDetails.mother_name"
                        class="w-full profile-input" /></div>
                <div><label>Mother Phone</label><input pInputText [(ngModel)]="studentDetails.mother_phone"
                        class="w-full profile-input" /></div>
                <div><label>Mother Email</label><input pInputText [(ngModel)]="studentDetails.mother_email"
                        class="w-full profile-input" /></div>
                <div><label>Mother Occupation</label><input pInputText [(ngModel)]="studentDetails.mother_occupation"
                        class="w-full profile-input" /></div>
                <div><label>Annual Income</label><input pInputText [(ngModel)]="studentDetails.annual_income"
                        class="w-full profile-input" /></div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Previous Education -->
    <p-accordion-panel value="6">
        <p-accordion-header>Previous Education</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div><label>Previous School</label><input pInputText [(ngModel)]="studentDetails.previous_school"
                        class="w-full profile-input" /></div>
                <div><label>Previous Class</label><input pInputText [(ngModel)]="studentDetails.previous_class"
                        class="w-full profile-input" /></div>
                <div><label>Previous Percentage</label><input pInputText
                        [(ngModel)]="studentDetails.previous_percentage" class="w-full profile-input" /></div>
                <div><label>Transfer Certificate</label><input pInputText
                        [(ngModel)]="studentDetails.transfer_certificate" class="w-full profile-input" /></div>
                <div><label>Achievements</label><input pInputText [(ngModel)]="studentDetails.achievements"
                        class="w-full profile-input" /></div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Academic -->
    <p-accordion-panel value="7">
        <p-accordion-header>Academic Details</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                    <label>Course</label>
                    <p-select [options]="allCourses" [(ngModel)]="studentDetails.course_id"
                        optionLabel="name" optionValue="course_id" appendTo="body" class="profile-select w-full"></p-select>
                </div>

                <div>
                    <label>Department</label>
                    <p-select [options]="departmentList"
                        [(ngModel)]="studentDetails.department_id" optionLabel="name" optionValue="dept_id"
                        appendTo="body" class="profile-select w-full"></p-select>
                </div>
                <div>
                    <label>Batch</label>
                    <p-select [options]="batchList" [(ngModel)]="studentDetails.batch_id"
                        optionLabel="batch_name" 
                        optionValue="id"
                        class="profile-select w-full"></p-select>
                </div>
                <div>
                    <label>Scholarship</label>
                    <p-select [options]="scholarshipTypeList"
                        [(ngModel)]="studentDetails.scholarship_id" optionLabel="name"
                       optionValue="scholarship_id"
                        class="profile-select w-full"></p-select>
                </div>
                <div>
                    <label>Fee Group</label>
                    <p-select [options]="feeCategoryList"
                        [(ngModel)]="studentDetails.fee_group_id" optionLabel="group_name"
                        optionValue="id"
                        class="profile-select w-full"></p-select>
                </div>
                <div>
                    <label>Section</label>
                    <input pInputText [(ngModel)]="studentDetails.section"
                        class="w-full profile-input" />
                </div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Hostel / Transport -->
    <p-accordion-panel value="8">
        <p-accordion-header>Hostel & Transport</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                    <label>Hostel Category</label>
                    <p-select [options]="hostelCategoryList"
                        [(ngModel)]="studentDetails.hostel_category" optionLabel="hostel_name"
                        optionValue="id"
                        class="profile-select w-full"></p-select>
                </div>

                <div>
                    <label>Transport Category</label>
                    <p-select [options]="transportRouteList"
                        [(ngModel)]="studentDetails.transport_category" optionLabel="route_name"
                        optionValue="id"
                        class="profile-select w-full"></p-select>
                </div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Misc -->
    <p-accordion-panel value="9">
        <p-accordion-header>Documents & Notes</p-accordion-header>
        <p-accordion-content>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div><label>Photo URL</label><input pInputText [(ngModel)]="studentDetails.photo_url"
                        class="w-full profile-input" /></div>
                <div><label>Signature URL</label><input pInputText [(ngModel)]="studentDetails.signature_url"
                        class="w-full profile-input" /></div>
                <div><label>Biometric ID</label><input pInputText [(ngModel)]="studentDetails.biometric_id"
                        class="w-full profile-input" /></div>
                <div><label>Notes</label><textarea pInputTextarea [(ngModel)]="studentDetails.notes" rows="3"
                        class="w-full profile-input"></textarea></div>
                <div><label>Status</label><input pInputText [(ngModel)]="studentDetails.status"
                        class="w-full profile-input" /></div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <!-- Other Details -->
    <p-accordion-panel value="10">
        <p-accordion-header>Other Details</p-accordion-header>
        <p-accordion-content>
            <div *ngIf="fieldValues" class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div *ngFor="let item of allLeadFeilds">
                    <div class="col-span-1 w-full">
                        <label class="block mb-2"
                            [ngClass]="{ 'requiredValue': item.required }">
                            {{ item.label }}
                        </label>

                        <!-- Regular Input -->
                        <input *ngIf="item.type !== 'select' && item.type !== 'textarea'"
                            pInputText class="w-full profile-input"
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [required]="item.required === true ? true : false"
                            [ngModelOptions]="{ standalone: false }" />

                        <!-- Textarea -->
                        <textarea *ngIf="item.type === 'textarea'" pTextarea
                            style="box-shadow: none !important;" class="w-full"
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [required]="item.required === true ? true : false"
                            placeholder="{{ item.placeholder }}"></textarea>

                        <!-- Select -->
                        <p-select *ngIf="item.type === 'select'" class="w-full profile-select"
                            appendTo="body" [required]="item.required === true ? true : false"
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [options]="item.data" [placeholder]="item.placeholder"></p-select>
                    </div>
                </div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

</p-accordion>

<div class="flex justify-end mt-4">
    <p-button label="Save Changes" 
    [disabled]="loading"
    [loading]="loading"
    icon="pi pi-save" (onClick)="updateStudent()"></p-button>
</div>